(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["eg-offer"] && !Shopify.designMode) return;
  try {
    if(!window.egOfferTimer){
 window.egOfferTimer=true;
 const update=()=>document.querySelectorAll('[data-eg-offer]').forEach(root=>{
  const end=Number(root.dataset.end)*1000;
  if(!end)return;
  const remaining=Math.floor((end-Date.now())/1000);
  if(remaining<=0){root.querySelectorAll('[data-eg-expiring]').forEach(el=>el.hidden=true);return;}
  const counter=root.querySelector('[data-eg-countdown]');
  if(!counter)return;
  const active=remaining<=Number(root.dataset.window);
  counter.hidden=!active;
  if(active){const d=Math.floor(remaining/86400),h=Math.floor(remaining%86400/3600),m=Math.floor(remaining%3600/60);root.querySelector('[data-eg-clock]').textContent=(d?d+'d ':'')+h+'h '+m+'m';}
 });
 update();setInterval(update,30000);document.addEventListener('shopify:section:load',update);
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["eh-behavior"] && !Shopify.designMode) return;
  try {
    (() => {
 const aborters = new WeakMap();
 const fitName = card => {
  const name = card.querySelector('[data-eh-card-name]');
  if (!name) return;
  name.style.fontSize = '';
  const base = parseFloat(getComputedStyle(name).fontSize);
  if (name.scrollWidth > name.clientWidth && name.clientWidth > 0) name.style.fontSize = (base * name.clientWidth / name.scrollWidth * 0.97) + 'px';
 };
 const updateNames = root => {
  const input = root.querySelector('[data-eh-name]');
  if (!input) return;
  const value = input.value.normalize('NFC').trim();
  document.querySelectorAll('[data-eh-card]').forEach(card => {
   if (card.dataset.productId !== root.dataset.productId) return;
   const name = card.querySelector('[data-eh-card-name]');
   name.textContent = value || name.dataset.default;
   name.classList.toggle('is-placeholder', !value);
   fitName(card);
  });
  const sticky = root.querySelector('[data-eh-sticky-cta]');
  if (sticky) sticky.textContent = value ? sticky.dataset.ready : sticky.dataset.personalize;
 };
 const init = root => {
  if (aborters.has(root)) return;
  const controller = new AbortController(), signal = controller.signal;
  aborters.set(root,controller);
  const previewView=new URL(location.href).searchParams.get('view');
  if(previewView===root.dataset.template)root.querySelectorAll('.eg-box-switch a').forEach(link=>{const target=new URL(link.href);target.searchParams.set('view',previewView);link.href=target.href;});
  const form = root.querySelector('.eh-purchase-form'), input = root.querySelector('[data-eh-name]'), variant = root.querySelector('[data-eh-variant]');
  const sticky = root.querySelector('[data-eh-sticky-cta]'), bar = root.querySelector('[data-eh-sticky]');
  if (input) {
   try { const key = 'eh-name-' + root.dataset.productId, saved = sessionStorage.getItem(key); if (saved !== null) { input.value = saved; sessionStorage.removeItem(key); } } catch {}
   input.addEventListener('input',() => { input.setCustomValidity(''); updateNames(root); },{signal});
   input.addEventListener('blur',() => { const status=root.querySelector('[data-eh-name-status]'); if(status)status.textContent=input.value.trim()?status.dataset.updated:''; },{signal});
   form?.addEventListener('submit',event => {
    input.value = input.value.normalize('NFC').trim();
    input.setCustomValidity(input.value ? '' : root.dataset.nameError);
    updateNames(root);
    if (!input.checkValidity()) { event.preventDefault(); event.stopImmediatePropagation(); input.reportValidity(); input.focus(); }
   },{capture:true,signal});
   updateNames(root);
  }
  if(form){
   let submitting=false,unlock;
   form.addEventListener('submit',event=>{
    if(event.defaultPrevented)return;
    if(submitting){event.preventDefault();event.stopImmediatePropagation();return;}
    submitting=true;form.setAttribute('aria-busy','true');
    unlock=setTimeout(()=>{submitting=false;form.removeAttribute('aria-busy');},3000);
   },{capture:true,signal});
   signal.addEventListener('abort',()=>clearTimeout(unlock),{once:true});
  }
  if (variant) variant.addEventListener('change',() => {
   if (input) try { sessionStorage.setItem('eh-name-'+root.dataset.productId,input.value); } catch {}
   const url = new URL(location.href);url.searchParams.set('variant',variant.value);location.assign(url.href);
  },{signal});
  if(sticky && form) sticky.addEventListener('click',event => {
   event.preventDefault();
   if (input) { input.value=input.value.normalize('NFC').trim();input.setCustomValidity(input.value?'':root.dataset.nameError); }
   if(!form.checkValidity()) { const invalid=form.querySelector(':invalid');invalid?.scrollIntoView({block:'center'});invalid?.focus({preventScroll:true});form.reportValidity();return; }
   const button=form.querySelector('[name="add"]');
   if(button&&!button.disabled)form.requestSubmit(button);
  },{signal});
  if(bar&&form&&'IntersectionObserver' in window){
   const observer=new IntersectionObserver(entries=>{const entry=entries[0];bar.hidden=entry.isIntersecting||entry.boundingClientRect.top>0;},{threshold:0});
   observer.observe(form);signal.addEventListener('abort',()=>observer.disconnect(),{once:true});
  }
  const gallery=root.querySelector('[data-eh-gallery]');
  if(gallery){
   const track=gallery.querySelector('[data-eh-track]'),slides=[...gallery.querySelectorAll('[data-eh-slide]')],thumbs=[...gallery.querySelectorAll('[data-eh-thumb]')];
   const previous=gallery.querySelector('[data-eh-prev]'),next=gallery.querySelector('[data-eh-next]'),counter=gallery.querySelector('[data-eh-count]');
   let index=0,ticking=false;
   const current=()=>{let distance=Infinity;const left=track.getBoundingClientRect().left;slides.forEach((slide,i)=>{const d=Math.abs(slide.getBoundingClientRect().left-left);if(d<distance){index=i;distance=d;}});thumbs.forEach((thumb,i)=>{if(i===index)thumb.setAttribute('aria-current','true');else thumb.removeAttribute('aria-current');});if(counter)counter.textContent=(index+1)+' / '+slides.length;if(previous)previous.disabled=index===0;if(next)next.disabled=index===slides.length-1;};
   const move=i=>{i=Math.max(0,Math.min(slides.length-1,i));const left=slides[i].offsetLeft-slides[0].offsetLeft;track.scrollTo({left,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});};
   gallery.querySelector('[data-eh-controls]')?.removeAttribute('hidden');
   previous?.addEventListener('click',()=>move(index-1),{signal});next?.addEventListener('click',()=>move(index+1),{signal});
   thumbs.forEach((thumb,i)=>thumb.addEventListener('click',event=>{event.preventDefault();move(i);},{signal}));
   track.addEventListener('scroll',()=>{if(ticking)return;ticking=true;requestAnimationFrame(()=>{current();ticking=false;});},{passive:true,signal});
   track.addEventListener('keydown',event=>{if(event.key==='ArrowRight'||event.key==='ArrowLeft'){event.preventDefault();move(index+(event.key==='ArrowRight'?1:-1));}},{signal});current();
   const dialog=gallery.querySelector('[data-eh-dialog]');
   if(dialog?.showModal){
    let opener;
    gallery.querySelectorAll('[data-eh-zoom]').forEach(link=>link.addEventListener('click',event=>{event.preventDefault();opener=link;const image=dialog.querySelector('img');image.src=link.href;image.alt=link.querySelector('img')?.alt||'';dialog.showModal();},{signal}));
    dialog.querySelector('[data-eh-close]').addEventListener('click',()=>dialog.close(),{signal});
    dialog.addEventListener('click',event=>{if(event.target===dialog)dialog.close();},{signal});
    dialog.addEventListener('close',()=>opener?.focus(),{signal});
   }
  }
  document.addEventListener('toggle',event=>{if(event.target.matches('.eg-card-preview'))requestAnimationFrame(()=>document.querySelectorAll('[data-eh-card]').forEach(fitName));},{capture:true,signal});
  if('ResizeObserver' in window){const observer=new ResizeObserver(()=>document.querySelectorAll('[data-eh-card]').forEach(fitName));observer.observe(root);document.querySelectorAll('[data-eh-card]').forEach(card=>observer.observe(card));signal.addEventListener('abort',()=>observer.disconnect(),{once:true});}
 };
 const initAll = scope => {scope.querySelectorAll('[data-eh-product]').forEach(init);document.querySelectorAll('[data-eh-product]').forEach(updateNames);};
 initAll(document);
 document.fonts?.ready.then(()=>document.querySelectorAll('[data-eh-card]').forEach(fitName));
 document.addEventListener('shopify:section:load',event=>initAll(event.target));
 document.addEventListener('shopify:section:unload',event=>event.target.querySelectorAll('[data-eh-product]').forEach(root=>{aborters.get(root)?.abort();aborters.delete(root);}));
})();
  } catch(e) { console.error(e); }
})();

})();
